const PETITION_CHANNELS = [
    { value: 'phone_call', text: 'Llamada telefónica' },
    { value: 'centralita', text: 'Centralita' },
    { value: 'whatsapp', text: 'Whatsapp' },
    { value: 'yummy_app', text: 'App Yummy' },
    { value: 'chat_bot', text: 'Chatbot' },
];

export { PETITION_CHANNELS };
